import { __awaiter } from "tslib";
import { Backend } from './backend';
import { AppState } from '../etc/stores';
import { Container } from './container';
import { StatefulService } from './stateful-service';
export var SocialRewardsStatusEnum;
(function (SocialRewardsStatusEnum) {
    SocialRewardsStatusEnum["ACTIVE"] = "active";
    SocialRewardsStatusEnum["INACTIVE"] = "inactive";
})(SocialRewardsStatusEnum || (SocialRewardsStatusEnum = {}));
export var SocialRewardsTypeEnum;
(function (SocialRewardsTypeEnum) {
    SocialRewardsTypeEnum["FACEBOOK_SHARE"] = "facebook-share";
    SocialRewardsTypeEnum["FACEBOOK_LIKE"] = "facebook-like";
    SocialRewardsTypeEnum["INSTAGRAM_FOLLOW"] = "instagram-follow";
    SocialRewardsTypeEnum["TWITTER_FOLLOW"] = "twitter-follow";
    SocialRewardsTypeEnum["TWITTER_SHARE"] = "twitter-share";
    SocialRewardsTypeEnum["YOUTUBE_SUBSCRIBE"] = "youtube-subscribe";
    SocialRewardsTypeEnum["TIKTOK_FOLLOW"] = "tiktok-follow";
    SocialRewardsTypeEnum["PINTEREST_FOLLOW"] = "pinterest-follow";
})(SocialRewardsTypeEnum || (SocialRewardsTypeEnum = {}));
export class SocialRewards extends StatefulService {
    constructor() {
        super(...arguments);
        this.backend = this.ctx.get(Backend);
    }
    loadState() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadSocialRewards();
        });
    }
    loadSocialRewards() {
        return __awaiter(this, void 0, void 0, function* () {
            const { business } = this.getAppState();
            const socialReward = yield this.backend.getBusinessSocialRewards(business.id);
            AppState.update(state => (Object.assign(Object.assign({}, state), { socialReward: socialReward.filter(item => item.status === 'active') })));
        });
    }
}
Container.add(SocialRewards);
